import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SectionBlock from './../SectionBlock/SectionBlock';
import ScoreBarNG from './../ScoreBarNG/ScoreBarNG';
import ScoreBarTypes from './../../constants/ScoreBarTypes';
import RequestedLevel from './../RequestedLevel/RequestedLevel';
import ReportSectionHeading from './../ReportSectionHeading/ReportSectionHeading';
import style from './style/smallscorebarsection.scss';

export default class SmallScoreBarSection extends Component {
    render() {
        const {
            title,
            children,
            scoreMin,
            scoreMax,
            scoreValue,
            iconText,
            iconType,
            scoreLevelDescription,
            scoreBarConfig,
            scoreBarType,
            classes,
            displayScore,
            evaluation,
            developabilityScore,
            developabilityLabel,
            developabilityDefinition,
            participantRequestedLevel,
            autoScaleWidth,
            valueLabelDisplay
        } = this.props;

        return (
            <React.Fragment>
                <SectionBlock
                    classes={{
                        root: `${participantRequestedLevel ? style.scoreBlockWithRequestedLevel : style.scoreBlock} ${classes.root}`
                    }}
                >
                    <ReportSectionHeading
                        title={ title }
                        iconType={ iconType }
                        iconText={ iconText }
                        introHeading={ false }
                        classes={{
                            reportSectionHeading: classes.reportSectionHeading,
                            roundIcon: {
                                root: classes.roundIcon && classes.roundIcon.root
                                    ? classes.roundIcon.root
                                    : '',
                                roundIconFigureWrapper: classes.roundIcon && classes.roundIcon.roundIconFigureWrapper
                                    ? classes.roundIcon.roundIconFigureWrapper
                                    : ''
                            }
                        }}
                    />

                    <ScoreBarNG
                        classes={{
                            root: `${style.scoreBar} ${classes.scoreBar}`,
                            fill: classes.fill,
                            blank: classes.blank,
                            scoreBar: classes.scoreBar,
                            displayScore: classes.displayScore,
                            titleWrapper: classes.titleWrapper,
                            barGraph: classes.barGraph
                        }}
                        scoreMin={ scoreMin }
                        scoreMax={ scoreMax }
                        scoreValue={ scoreValue }
                        scoreBarConfig={ scoreBarConfig }
                        displayScore={ displayScore }
                        developabilityScore={ developabilityScore }
                        developabilityLabel={ developabilityLabel }
                        developabilityDefinition={ developabilityDefinition }
                        scoreBarType={ scoreBarType }
                        autoScaleWidth={ autoScaleWidth }
                        evaluation={ evaluation }
                        valueLabelDisplay={ valueLabelDisplay }
                    />

                    <p className={ `${style.scoreLevel} ${classes.scoreLevel}` } dangerouslySetInnerHTML={{ __html: scoreLevelDescription }}/>
                    { children }
                </SectionBlock>
                { participantRequestedLevel
                    ? <RequestedLevel text={ participantRequestedLevel } />
                    : null }
            </React.Fragment>
        );
    }
}

SmallScoreBarSection.propTypes = {
    title: PropTypes.string,
    scoreMin: PropTypes.number,
    scoreValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    scoreMax: PropTypes.number,
    iconText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    iconType: PropTypes.string,
    scoreLevelDescription: PropTypes.string,
    scoreBarConfig: PropTypes.object,
    scoreBarType: PropTypes.oneOf(
        [ScoreBarTypes.CROISSANT, ScoreBarTypes.NORMAL, ScoreBarTypes.BAR_GRAPH, ScoreBarTypes.CUTOFF]
    ),
    displayScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    evaluation: PropTypes.string,
    participantRequestedLevel: PropTypes.string,
    classes: PropTypes.shape({
        root: PropTypes.string,
        scoreSecondaryTitle: PropTypes.string,
        barGraph: PropTypes.shape({
            root: PropTypes.string,
            fill: PropTypes.string,
            blank: PropTypes.string
        }),
        displayScore: PropTypes.string,
        titleWrapper: PropTypes.string,
        reportSectionHeading: PropTypes.string,
        roundIcon: PropTypes.shape({
            root: PropTypes.string,
            roundIconFigureWrapper: PropTypes.string
        })
    }),
    developabilityLabel: PropTypes.string,
    developabilityScore: PropTypes.string,
    developabilityDefinition: PropTypes.string,
    autoScaleWidth: PropTypes.bool,
    valueLabelDisplay: PropTypes.string
};

SmallScoreBarSection.defaultProps = {
    title: '',
    scoreMin: 0,
    scoreValue: 0,
    scoreMax: 0,
    iconText: '',
    iconType: 'desktop',
    scoreLevelDescription: '',
    scoreBarConfig: {},
    ScoreBarType: ScoreBarTypes.NORMAL,
    participantRequestedLevel: null,
    classes: {
        root: '',
        fill: '',
        blank: '',
        scoreBar: '',
        scoreSecondaryTitle: '',
        barGraph: {
            root: '',
            fill: '',
            blank: ''
        },
        displayScore: '',
        titleWrapper: '',
        reportSectionHeading: '',
        roundIcon: {
            root: '',
            roundIconFigureWrapper: ''
        }
    },
    developabilityLabel: '',
    developabilityScore: '',
    developabilityDefinition: ''
};
